import React, { useState, forwardRef } from "react";
import { Input, InputProps } from "./input";
import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";
import { focusStyles } from "../../utils/focus-styles.ts";
import { cn } from "../../utils/cn.ts";

type PasswordInputProps = Omit<InputProps, "type">;

//Icon styles
const iconContainerStyle = "absolute inset-y-0 right-0 pr-0.5 flex items-center cursor-pointer";
const baseIconStyle = "text-l text-light-slate p-3.5 bg-neutral-white";
const showIcon = "fa-sharp fa-regular fa-eye";
const hideIcon = "fa-sharp fa-regular fa-eye-slash";

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setPasswordVisible(!passwordVisible);
  };

  const renderTrailingIcon = () => {
    const iconStyle: string[] = [baseIconStyle];

    if (props.state != "disabled") {
      if (passwordVisible) {
        iconStyle.push(hideIcon);
      } else {
        iconStyle.push(showIcon);
      }
    } else {
      iconStyle.push("hidden");
    }

    return (
      <button
        className={cn([focusStyles, iconContainerStyle])}
        onClick={(event) => togglePasswordVisibility(event)}
        type="button"
        aria-label="Toggle view password"
      >
        <i className={iconStyle.join(" ")} />
      </button>
    );
  };

  return (
    <Input ref={ref} type={passwordVisible ? "text" : "password"} renderTrailingIcon={renderTrailingIcon} {...props} />
  );
});

PasswordInput.displayName = "PasswordInput";
